<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>The Modern Myths</h1>
<h1 class="bk1">Adventures in the Machinery of the Popular Imagination</h1>
<p class="bkau">Philip Ball</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago &amp; London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-ball-0003.vue?06345c3e